import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import { App } from './app/App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Suspense: i18n namespaces load lazily over HTTP */}
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </StrictMode>,
);
